import { ConnectedAccount } from '@services/stripe-connect/types/connected-account';

export const isConnectedAccountReady = (account?: ConnectedAccount) => {
  if (!account) {
    return false;
  }

  return account.status === 'active' && account.transfersEnabled;
};
